import React from 'react'
import { ErrorBoundary } from 'secondstep-components'
import PropTypes from 'prop-types'
import { Route } from 'react-router'
import SchoolSummary from 'pages/SchoolSummary'
import { PageWrapper } from './component.styles'

const K8Report = ({ entry, match, navigationHandler, schoolEmptyDisplay }) => {
  return (
    <ErrorBoundary>
      <PageWrapper>
        <Route
          path={`${match.path}/:unitSection`}
          render={routeProps => (
            <SchoolSummary
              entry={entry}
              k8ReportUnitSection={routeProps.match.params.unitSection}
              navigationHandler={navigationHandler}
              schoolEmptyDisplay={schoolEmptyDisplay}
            />
          )}
        />
      </PageWrapper>
    </ErrorBoundary>
  )
}

K8Report.propTypes = {
  entry: PropTypes.object,
  match: PropTypes.object,
  navigationHandler: PropTypes.func,
  schoolEmptyDisplay: PropTypes.object,
  siteId: PropTypes.string,
}

export default K8Report
